export default class GetUsersRequest {
    public showDeleted: boolean = false;

    public roleNames: string[] = [];
}